import { CONCURRENCY_OPTIONS, QUALITY_OPTIONS } from '../../constants';
import { events } from '../../events';
import { BaseComponent } from '../../framework/base.component';
import { component } from '../../framework/component.decorator';
import { OnDestroy } from '../../framework/on-destroy.interface';
import { menu } from '../../menu';
import { store } from '../../store';
import { button } from '../../templating/button.element';
import { icon } from '../../templating/icon.element';
import { MenuOption } from '../../types/menu-option.type';

import styles from './settings.component.scss';

@component({
  selector: 'app-settings',
  styles,
})
export class SettingsComponent
  extends BaseComponent<SettingsComponent>
  implements OnDestroy
{
  constructor() {
    super(SettingsComponent);
  }

  async createInitialComponent() {
    return [
      button(
        {
          onCreate: (element) => {
            element.title = 'Settings';
            element.addEventListener('click', () => this.openRootMenu());
          },
        },
        [icon('gear-wide-connected')]
      ),
    ];
  }

  onDestroy(): void {}

  private async openRootMenu() {
    await menu<MenuOption<string | null>>(() => [
      {
        meta: true,
        text: 'Settings',
        value: null,
      },
      {
        text: 'Quality',
        icon: 'sliders',
        value: 'quality',
        callback: async () => this.onQuality(),
      },
      {
        text: 'Concurrency',
        icon: 'bar-chart-steps',
        value: 'concurrency',
        callback: async () => this.onConcurrency(),
      },
    ]);
  }

  private onQuality() {
    const choices = [
      {
        meta: true,
        text: 'Choose output format and quality',
      } as MenuOption<any>,
      {
        text: 'Back',
        icon: 'arrow-left',
        callback: () => this.openRootMenu(),
        value: null,
      } as MenuOption<any>,
      ...QUALITY_OPTIONS.map((choice) => {
        const defaultChoice = store.get('quality') || QUALITY_OPTIONS[0];

        if (
          !choice.meta &&
          choice.value !== null &&
          choice.value.mime === defaultChoice.value?.mime &&
          choice.value.quality === defaultChoice.value?.quality
        ) {
          return { ...choice, selected: true };
        }

        return choice;
      }),
    ];

    menu(() => choices)
      .then((quality) => events.emit('set-quality', { quality }))
      .catch((err) => events.emit('warn', err));
  }

  private onConcurrency() {
    const choices = [
      { meta: true, text: 'Choose number of workers' } as MenuOption<any>,
      {
        text: 'Back',
        icon: 'arrow-left',
        callback: () => this.openRootMenu(),
        value: null,
      } as MenuOption<any>,
      ...CONCURRENCY_OPTIONS.map((choice) => {
        const defaultChoice =
          store.get('concurrency') || CONCURRENCY_OPTIONS[3];

        if (!choice.meta && choice.value === defaultChoice.value) {
          return { ...choice, selected: true };
        }

        return choice;
      }),
    ];

    menu(() => choices)
      .then((concurrency) => events.emit('set-concurrency', { concurrency }))
      .catch((err) => events.emit('warn', err));
  }
}
